import React, { useState, useEffect } from 'react';
import MailingListForm from './MailingListForm';
import Modal from 'react-modal';
import { Fade } from 'react-awesome-reveal';
import './MailingListModal.css';

const MailingListModal = () => {
    const [modalIsOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const hasSubscribed = sessionStorage.getItem('hasSubscribedToMailingList');
        if (!hasSubscribed) {
            const timer = setTimeout(() => {
                setIsOpen(true);
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, []);
    
    const closeModal = () => {
        setIsOpen(false);
        sessionStorage.setItem('hasSubscribedToMailingList', 'true');
    };
    
    const handleSuccessfulSubscribe = () => {
        setIsOpen(false);
        sessionStorage.setItem('hasSubscribedToMailingList', 'true');
    };

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Large Map"
            className="mailing_subscribe_modal"
            overlayClassName="overlay"
        >
            <div className='modal_exit' onClick={closeModal}></div>
            <Fade duration={2000}>
                <MailingListForm onSuccess={handleSuccessfulSubscribe} />
            </Fade>
        </Modal>
    );
};

export default MailingListModal;
